<template>
    <div @click="$emit('click'), localActive = !localActive" class="badge" :class="localActive ? 'bg-' + color : 'bg-' + color + '-hover'">
      <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "badge",
        props: {
          color: {
            type: String
          },
          active: {
            type: Boolean
          }
        },
      data() {
          return {

            localActive: null,

          }
      },
      created() {
          this.localActive = this.active;
      }
    }
</script>

<style scoped>

  .badge {
    display: inline-flex;
    padding: 0.3rem 0.5rem;
    background-color: #c9c9c9;
    color: white;
    border-radius: 1rem;
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    font-size: 0.9rem;
    margin: 0 0.2rem;
    cursor: pointer;
  }

  .bg-primary {
    background-color: #32CC99;
  }

  .bg-green {
    background-color: #67C23A;
  }

  .bg-red {
    background-color: #F56C6C;
  }

  .bg-blue {
    background-color: #2b57a3;
  }

  .bg-primary-hover:hover {
    background-color: #32CC99;
  }

  .bg-green-hover:hover {
    background-color: #67C23A;
  }

  .bg-red-hover:hover {
    background-color: #F56C6C;
  }

  .bg-blue-hover:hover {
    background-color: #2b57a3;
  }

</style>



// WEBPACK FOOTER //
// src/components/badge.vue